import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlertsReportComponent } from './alerts-report/alerts-report/alerts-report.component';
import { BillingComponent } from './billing/billing.component';
import { DeviceReportComponent } from './device-report/device-report.component'
import { DeviceListReportComponent } from './device-list-report/device-list-report.component';
import { MonitoringStreamComponent } from './monitoring-stream/monitoring-stream/monitoring-stream.component';
import { CellularReportCenterComponent } from './cellular-report-center/cellular-report-center.component';
import { CellularBillingRootGuard } from 'src/app/shared/services/cellular-billing-root.guard';
import { CellularReportReviewComponent } from './cellular-report-center/cellular-report-review/cellular-report-review.component';
import { OverlayBundlesComponent } from './cellular-report-center/overlay-bundles/overlay-bundles.component';
import { CellularReportUnsavedGuard } from 'src/app/shared/services/cellular-report-unsaved.guard';
import { BillingPricingComponent } from './cellular-report-center/billing-pricing/billing-pricing.component';

const routes: Routes = [
  { path: 'cellular-reports/pricing', component: BillingPricingComponent, canActivate: [CellularBillingRootGuard] },
  { path: 'cellular-reports/overlay-bundles', component: OverlayBundlesComponent, canActivate: [CellularBillingRootGuard] },
  { path: 'cellular-reports/review/:reportId', component: CellularReportReviewComponent, canActivate: [CellularBillingRootGuard], canDeactivate: [CellularReportUnsavedGuard] },
  { path: '', redirectTo: 'overview', pathMatch: 'full' },
  { path: 'overview', component: DeviceReportComponent },
  { path: 'overview/:id', component: DeviceReportComponent },
  { path: 'billing', component: BillingComponent },
  { path: 'billing/:id', component: BillingComponent },
  { path: 'device-list', component: DeviceListReportComponent },
  { path: 'device-list/:id', component: DeviceListReportComponent },
  { path: 'alerts', component: AlertsReportComponent },
  { path: 'alerts/:id', component: AlertsReportComponent },
  { path: 'monitoring', component: MonitoringStreamComponent },
  { path: 'monitoring/:id', component: MonitoringStreamComponent },
  {
    path: 'cellular-reports',
    component: CellularReportCenterComponent,
    canDeactivate: [CellularReportUnsavedGuard],
    canActivate: [CellularBillingRootGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }
